<template>
  <div class="checkbox">
    <label :style="labelStyle">
      <input
        type="checkbox"
        @change="$emit('input', $event.target.checked)"
        v-bind="$attrs"
        :checked="value"
      >
      <i></i>
      <span>{{ label }}</span>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'OrangeCheckbox',
    props: {
      label: String,
      value: Boolean,
      offLabelColor: String,
    },
    computed: {
      checked () {
        return this.value
      },
      labelStyle () {
        const styles = {}
        if (this.offLabelColor && !this.checked) {
          styles.color = this.offLabelColor
        }
        return styles
      },
    },
    methods: {
      change ($event) {
        this.$emit('input', $event.target.checked)
      },
    },
  }
</script>

<style lang="less" scoped>
.checkbox {
  label {
    display: block;
    padding-left: 30px;
    // font-family: 'Roboto', Arial, sans-serif;
    font-weight: 300;
    font-size: 14px;
    line-height: 1;
    position: relative;
    cursor: pointer;

    i {
      display: block;
      width: 17px;
      height: 17px;
      border: 1px solid #CCC;
      border-radius: 2px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      margin-right: 20px;
    }
    input {
      display: none;

      &:checked + i:after {
        content: '';
        width: 20px;
        height: 18px;
        background-image: url('/img/icons/ui/orange-checkbox.svg');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        top: calc(50% + -3px);
        left: -2px;
        transform: translateY(-50%);
      }
    }
  }

}
</style>
